var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkIsotype = function SvgSparkIsotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spark-isotype_svg__a)",
    d: "M22.766 20.305H35.71c.498 0 .599-.678.146-.885L22.767 13.46V.464c0-.485-.649-.644-.873-.214l-5.38 10.36-5.963-2.738c-.57-.23-.921.234-.727.634l3.555 7.334H.435c-.498 0-.598.678-.145.885l13.089 5.962V35.68c0 .485.648.644.872.214l5.381-10.36 5.963 2.738c.57.23.92-.234.727-.633z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spark-isotype_svg__a",
    x1: 29.133,
    x2: 5.826,
    y1: 9.59,
    y2: 27.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA43BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA930"
  })))));
};
export default SvgSparkIsotype;